<template>
  <Account
    v-if="loaded"
    :me="me"
    :password-min-length="passwordMinLength"
    :active-tab="activeTab"
    @updateMe="updateMe"
    @updateSettings="updateSettings" />
</template>
<script>
import _ from 'lodash';
import { mapState, mapActions } from 'vuex';
import recordUpdatedNotify from 'src/mixins/showUpdateNotification';
import Account from './_components/Account.vue';

export default {
  name: 'AccountModule',
  components: {
    Account,
  },
  mixins: [recordUpdatedNotify],
  data() {
    return {
      activeTab: '',
      loaded: false,
    };
  },
  computed: {
    ...mapState('me', {
      me: state => state.account,
    }),
    ...mapState('user', {
      passwordMinLength: state => state.passwordMinLength,
    }),
  },
  async created() {
    await this.fetchMe();
    this.subscribeToUserUpdated();
    if (this.$route.meta.isTab) {
      this.activeTab = this.$route.path || '';
    }
    this.loaded = true;
  },
  beforeDestroy() {
    this.unsubscribeToUserUpdated();
  },
  beforeRouteUpdate(to, from, next) {
    if (to.meta.isTab && to.path) {
      this.activeTab = to.path;
    }
    next();
  },
  methods: {
    ...mapActions('me', [
      'fetchMe',
      'updateAccount',
      'updateSettings',
    ]),
    ...mapActions('user', [
      'subscribeToUserUpdated',
      'unsubscribeToUserUpdated',
    ]),
    async updateMe(update) {
      this.updateAccount(update);
    },
  },
  watch: {
    me: _.debounce(function updated(record, oldRecord) {
      this.showUpdateNotification({ record, oldRecord });
    }, 500, { trailing: true }),
  },
};
</script>
